<template>
  <ion-page>
    <ion-content
      ref="content"
      fullscreen
      class="c-intro-slider"
      scroll-y="false"
    >
      <!-- <ion-button
        @click="$router.go(-1)"
        color="light"
        class="c-intro-slider__close"
        fill="clear"
      >
        <ion-icon slot="icon-only" :icon="close"></ion-icon>
      </ion-button> -->
      <back-button
        :defaultHref="{ name: 'login' }"
        :icon="close"
        text=""
        class="c-intro-slider__close"
        color="light"
      >
      </back-button>
      <ion-slides
        @ionSlidesDidLoad="$refs.introSlider.$el.update()"
        pager="true"
        :options="slideOpts"
        ref="introSlider"
      >
        <ion-slide>
          <div class="c-bubble-grid">
            <div class="c-bubble-grid__top">
              <ion-grid fixed>
                <ion-row>
                  <ion-col>
                    <!-- <img src="https://dummyimage.com/100x100/ccc/fff" alt="" /> -->
                    <img src="@/assets/img/intro/doc_finder.svg" />
                  </ion-col>
                </ion-row>
              </ion-grid>
            </div>
            <div class="c-bubble-grid__bottom">
              <ion-grid class="ion-align-items-center" fixed>
                <ion-row>
                  <ion-col>
                    <b>Ihre Gesundheit. Unser Anliegen.</b>
                    <p>
                      Roodie nimmt Ihnen ab jetzt die ewige Suche im Internet
                      ab. Sagen Sie uns einfach, was Ihnen fehlt.
                    </p>
                    <!-- <div class="ion-text-right">
                      <ion-button
                        fill="outline"
                        router-link="/registrierung"
                        color="primary"
                        class="ion-margin-bottom"
                        >Zur Registrierung</ion-button
                      >
                      <ion-button
                        @click="nextSlide()"
                        color="primary"
                        class="ion-margin-bottom"
                        >Weiter</ion-button
                      >
                    </div> -->
                  </ion-col>
                </ion-row>
              </ion-grid>
            </div>
          </div>
        </ion-slide>

        <ion-slide>
          <div class="c-bubble-grid">
            <div class="c-bubble-grid__top">
              <ion-grid fixed>
                <ion-row>
                  <ion-col>
                    <img src="@/assets/img/intro/befunde.svg" />
                  </ion-col>
                </ion-row>
              </ion-grid>
            </div>
            <div class="c-bubble-grid__bottom">
              <ion-grid class="ion-align-items-center" fixed>
                <ion-row>
                  <ion-col>
                    <b>Zweite Meinung gefragt?</b>
                    <p>
                      Lassen Sie Ihre Diagnose oder Behandlung von einem zweiten
                      Arzt checken.
                    </p>
                    <!-- <div class="ion-text-right">
                      <ion-button
                        fill="outline"
                        router-link="/registrierung"
                        color="primary"
                        class="ion-margin-bottom"
                        >Zur Registrierung</ion-button
                      >
                      <ion-button
                        @click="nextSlide()"
                        color="primary"
                        class="ion-margin-bottom"
                        >Weiter</ion-button
                      >
                    </div> -->
                  </ion-col>
                </ion-row>
              </ion-grid>
            </div>
          </div>
        </ion-slide>

        <ion-slide>
          <div class="c-bubble-grid">
            <div class="c-bubble-grid__top">
              <ion-grid fixed>
                <ion-row>
                  <ion-col>
                    <img src="@/assets/img/intro/doc_slider.svg" />
                  </ion-col>
                </ion-row>
              </ion-grid>
            </div>
            <div class="c-bubble-grid__bottom">
              <ion-grid class="ion-align-items-center" fixed>
                <ion-row>
                  <ion-col>
                    <b>Arztgespräch per Video?</b>
                    <p>
                      Egal wo Sie gerade sind, Tag und Nacht – schnell und
                      zuverlässig.
                    </p>
                    <!-- <div class="ion-text-right">
                      <ion-button
                        router-link="/registrierung"
                        color="primary"
                        class="ion-margin-bottom"
                        >Zur Registrierung</ion-button
                      >
                    </div> -->
                  </ion-col>
                </ion-row>
              </ion-grid>
            </div>
          </div>
        </ion-slide>
      </ion-slides>
      <div class="ion-text-right">
        <ion-button
          class="c-intro-slider__submit ion-padding-end"
          fill="outline"
          router-link="/registrierung"
          color="primary"
          >Zur Registrierung</ion-button
        >
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonPage,
  IonSlides,
  IonSlide,
  IonButton,
  IonGrid,
  IonRow,
  IonCol,
  IonContent,
  IonIcon,
  IonBackButton,
} from "@ionic/vue";
import { close } from "ionicons/icons";

export default {
  name: "Intro",
  components: {
    IonPage,
    IonSlides,
    IonSlide,
    IonButton,
    IonGrid,
    IonRow,
    IonCol,
    IonContent,
    IonIcon,
    IonBackButton,
  },
  data() {
    return {};
  },
  setup() {
    // const introSlider = ref(null);
    // Optional parameters to pass to the swiper instance. See http://idangero.us/swiper/api/ for valid options.
    const slideOpts = {
      //   direction: "vertical",
      //   notNextTick: true,
      //   Direction: "vertical",
      //   grabCursor: true,
      //   setWrapperSize: true,
      //   autoHeight: true,
      //   slidesPerView: 1,
      //   Mousewheel: true,
      //   mousewheelControl: true,
      //   Height: window.innerHeight,
      //   resistanceRatio: 0,
      //   observeParents: true,

      initialSlide: 0,
      speed: 400,
    };
    return { slideOpts, close };
  },
  methods: {
    nextSlide() {
      // introSlider?.value?.$el.getSwiper().slideNext();
      // console.log();
      this.$refs.introSlider.$el.slideNext();
      //  e.target.slideNext();
      // this.slideOpts.slideNext();
    },
  },
};
</script>

<style lang="scss">
.c-intro-slider {
  // background-size: cover !important;
  // background-repeat: no-repeat !important;
  // background-position: center center !important;
  // background-image: url("../assets/img/medgate_logo.svg");
  // --background: url("../assets/img/bubble_bg.svg") no-repeat center center/cover;
  --background: var(--ion-color-medium);

  &__submit::part(native) {
    background: var(--ion-color-medium);
  }

  &__close {
    position: absolute;
    top: calc(5px + var(--ion-safe-area-top));
    right: 5px;
    z-index: 9;
  }

  ion-slides {
    height: calc(100% - 60px);
  }

  .swiper-slide {
    display: block;
    padding-bottom: 30px;
    font-size: 16px;
    color: var(--ion-color-primary);
    text-align: left;
  }

  .swiper-slide h2 {
    margin-top: 2.8rem;
  }

  .swiper-slide img {
    /* max-height: 50%; */
    max-height: 40vh;
    max-width: 100%;
    /* max-width: 80%; */
    /* margin: 60px 0 40px; */
    pointer-events: none;
  }

  .swiper-pagination {
    bottom: 220px;
    left: 16px;
    width: auto;
  }

  @media (min-width: 820px) {
    --background: none;
    background: url("../assets/img/bubble_bg.svg") no-repeat center center/cover;

    .c-bubble-grid__top {
      text-align: center;
    }

    .swiper-pagination {
      bottom: 0;
      left: 0;
      right: 0;
    }
  }
}
</style>
